import React,{useEffect} from 'react';
import styled from '@emotion/styled';

import {FaTimes as CancelIcon} from 'react-icons/fa';
import { useModal } from '../../../hooks/Context';
import {ResetPassword} from '.';

const FirstModal = (props:any) => {
  const {setModalContent, setShowCancel, setShowModal, showCancel, showModal, modalContent} = useModal();
  const {userHasChangePassword,setUserHasChangePassword} = props.data;

  useEffect(()=>{
    let localChangePassword = localStorage.getItem('AdminUserHasChangePassword');
    if(!userHasChangePassword && localChangePassword != 'true'){
      setModalContent(<ResetPassword />);
      setShowCancel(false);
      setShowModal(true);
    } else {
      setShowModal(false);
    }
    
  },[])

  return (
    <>
       { 
        showModal ?
          <>
            <Wrapper >
                <div>
                    {showCancel?<span onClick={()=>{setShowModal(false)}}><CancelIcon/></span>:''}
                    {modalContent}
                </div>
            </Wrapper>
            <BackDrop onClick={()=>{setShowModal(false)}}/>
          </>
        :''}
    </>
   
  )
}

export default FirstModal;

const BackDrop = styled('div')`
    width: 100%;
    height:100%;
    position: fixed;
`


const Wrapper = styled.div`
    width:100%;
    position:fixed !important;
    top:0;
    left:0;
    z-index: 100;
    min-height: 100%;
    position:relative;
    justify-content: center;;
    display:flex;
    overflow-X:hidden;
    overflow-y:auto;
    background-color: rgba(78, 83, 79, 0.5);
    & > div{
        width:fit-content;
        position:relative;
        top:50px;
    }
    & > div > span{
        position:absolute;
        width:45px;
        height:45px;
        border-radius:50%;
        color:white;
        background-color:rgba(255,25,255,0.3);
        display:flex;
        justify-content:center;
        align-items: center;
        font-size:24px;
    }

`